import React, { FunctionComponent } from 'react';
import { Button as RaButton, useTranslate, useNotify } from 'react-admin';
import {
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
  Grid as MuiGrid,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Form as RffForm } from 'react-final-form';
import Input from '../../Input';
import { ModalFormProps } from './types';

const useStyles = makeStyles({
  hide: {
    display: 'none',
  },
  form: {
    width: '100%',
  },
  modalContent: {
    whiteSpace: 'pre-line',
  },
});

const ModalForm: FunctionComponent<ModalFormProps> = (props) => {
  const { title, open, handleClose, handleClick, inputs, resource } = props;
  let submit: () => unknown;
  const t = useTranslate();
  const classes = useStyles();
  const notify = useNotify();

  return (
    <MuiDialog fullWidth open={open} onClose={handleClose}>
      <MuiDialogTitle>{title}</MuiDialogTitle>
      <MuiDialogContent className={classes.modalContent}>
        {props.content && (
          <p style={{ marginBottom: '16px' }}>{t(props.content)}</p>
        )}
        <MuiGrid container spacing={2}>
          <RffForm
            onSubmit={(record) => {
              handleClick(record);
            }}
            resources={resource}
            className={classes.form}
            render={({ handleSubmit, ...restProps }) => {
              submit = handleSubmit;

              return (
                <>
                  {inputs.map((input) => (
                    <MuiGrid
                      key={input.source}
                      item
                      xs={12}
                      sm={input.width || 12}
                    >
                      <Input
                        {...input}
                        {...restProps}
                        key={input.source}
                        {...(input.hide && { className: classes.hide })}
                        {...(input.multiline && {
                          multiline: true,
                        })}
                        fullWidth
                      />
                    </MuiGrid>
                  ))}
                </>
              );
            }}
          />
        </MuiGrid>
      </MuiDialogContent>
      <MuiDialogActions>
        <RaButton
          onClick={() => {
            if (
              resource === 'invoices' &&
              title === t('action.cancel_draft.modal.title')
            ) {
              notify('notify.invoice.cancel_draft.success', {
                type: 'success',
              });
            } else if (
              resource === 'invoices' &&
              title === t('action.cancel.modal.title')
            ) {
              notify('notify.credit.systeme.sended.success', {
                type: 'success',
              });
            } else if (
              title === t('action.generate_a_new_invoice.modal.title')
            ) {
              notify('notify.generate.new.invoice.success', {
                type: 'success',
              });
            }
            submit();
          }}
          key="button"
          label={
            resource == 'invoices'
              ? t('modal.confirm.confirm')
              : t('button.uppercase.ok')
          }
        />
        <RaButton onClick={handleClose} label={t('button.uppercase.cancel')} />
      </MuiDialogActions>
    </MuiDialog>
  );
};

export default ModalForm;
